<script>
let categories = [
      {
        pathIncludes: "/cakes",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top_Header_RecipeCategory_Cake_v2.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top_Header_RecipeCategory_Cake_Mobile.jpg",
        header: "Cakes",
        copy:"From classic white to bright and bold, our cake mixes will take your next party or get-together to the next level.",
      },
      {
        pathIncludes: "/bars",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Bars.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Bars-Mobile.jpg",
        header: "Bars",
        copy: "Need a tasty on-the-go snack that will make everyone happy? Try our collection of bar recipes and create memories that bring joy to the small moments.",
      },
        {
        pathIncludes: "/biscuits-and-scones",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Biscuits-Scones.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Biscuits-Scones-Mobile.jpg",
        header: "Biscuits & Scones",
        copy: "Up the ante on your baking basics with these delicious and easy biscuit and scone recipes.",
      },
        {
        pathIncludes: "/breakfast",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Breakfasts.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Breakfasts-Mobile.jpg",
        header: "Breakfast",
        copy: "Looking to amp up your morning routine? Break free from the norm and let Pillsbury breakfast products help kick start your day!",
      },
       {
        pathIncludes: "/brownies",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Brownies_v2.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Brownies_Mobile.jpg",
        header: "Brownies",
        copy:"Brownies are fitting for every occasion… brownie cookies, brownie ice cream sandwiches, brownie donuts—the opportunities are endless.",
      },
       {
        pathIncludes: "/fudges-candies-and-truffles",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Candies-Truffles.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Candies-Truffles-Mobile.jpg",
        header: "Candies & Truffles",
        copy:"Bite-sized happiness has never been easier to achieve with our delicious assortment of candy and truffle recipes.",
      },
         {
        pathIncludes: "/candies-and-truffles",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Candies-Truffles.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Candies-Truffles-Mobile.jpg",
        header: "Candies & Truffles",
        copy:"Bite-sized happiness has never been easier to achieve with our delicious assortment of candy and truffle recipes.",
      },
       {
        pathIncludes: "/cookies",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Cookies.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Cookies-Mobile.jpg",
        header: "Cookies",
        copy:"We’re all a little crazy for cookies, right? We have the cookie recipes you need to satisfy your sweet tooth and bring out your creative side. Make it fun and get the whole family involved or make it a solo activity and treat yourself.",
      },
      {
        pathIncludes: "/cupcakes",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Cupcakes_v2.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Cupcakes_Mobile.jpg",
        header: "Cupcakes",
        copy:"Cupcakes are handheld happiness. Whether you like vanilla, chocolate, or strawberry—you’re sure to be inspired by our cupcake recipes.",
      },
      {
        pathIncludes: "/desserts",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Desserts.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Desserts-Mobile.jpg",
        header: "Desserts",
        copy: "Let’s be real, dessert is everyone’s favorite course of a meal. Now the tough part is deciding which dessert recipe to go with.",
      },
      {
        pathIncludes: "/pies-and-cobblers",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Pies-Cobblers.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Pies-Cobblers-Mobile.jpg",
        header: "Pies & Cobblers",
        copy:"Heading to a family gathering? Or just feel like indulging in some sweets? Our pie and cobbler recipes will get you inspired to pre-heat the oven.",
      },
       {
        pathIncludes: "/coffee-cakes",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_RecipeCategories_CoffeeCake.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_RecipeCategories_CoffeeCake-Mobile.jpg",
        header: "Coffee Cakes",
        copy:"Nothing puts a pep in your step quicker than a tasty Pillsbury™ coffee cake. Our coffee cake recipes are simple, delicious, and share-worthy!",
      },
      {
        pathIncludes: "/main-courses",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_RecipeCategories_MainCourse.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_RecipeCategories_MainCourse-Mobile.jpg",
        header: "Main Courses",
        copy:"Looking for some fun and creative meal inspiration? Check out our main course recipes that are sure to be a family favorite.",
      },
      {
        pathIncludes: "/muffins",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_RecipeCategories_Muffins.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_RecipeCategories_Muffins-Mobile.jpg",
        header: "Muffins",
        copy:"Nothing smells quite as good as a Saturday morning with muffins in the oven! Our muffin recipes are sure to bring out the baker in anyone.",
      },
      {
        pathIncludes: "/snacks",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_Snacks.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_Snacks-Mobile.jpg",
        header: "Snacks",
        copy:"Sweet treats make the in-between moments even better. Our snack recipes are satisfying and easy for on-the-go snacking!",
      },
      {
        pathIncludes: "/breads",
        imgDesktop:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/10/Pillsbury_Top-Header_RecipeCategories_Breads.jpg",
        imgMobile:"https://pillsburyqa.wpengine.com/wp-content/uploads/2022/11/Pillsbury_Top-Header_RecipeCategories_Breads-Mobile.jpg",
        header: "Breads",
        copy: "Breads, muffins, and donuts—oh my! With these recipes you can make great breakfasts, everyday snacks, or sweet additions to any meal.",
      },
      ]
</script>

<section id="recipe-filter-banner" class="hero-banner simple-text white" data-acsb-overflower="true">
{#each categories as category}
{#if window.location.pathname.includes(`${category.pathIncludes}`)}

            <div class="image-wrapper" data-acsb-overflower="true">
                <img src="{category.imgMobile}" alt="Recipe Category page hero image"
                     class="hero-img mobile-img" aria-hidden="true" data-acsb-hidden="true">
                <img src="{category.imgDesktop}"
                     data-src="{category.imgDesktop}" class="hero-img desktop-img"
                     alt="Recipe Category page hero image">
            </div>
            <div class="overlay">
                <div class="outer-text-wrapper">
                    <div class="text-area">
                        <div class="header">
                            <img src="/wp-content/uploads/2021/04/icon-spatula.png"
                                 class="icon" alt="White plastic fork clip art">
                           
                            <h1>{category.header}</h1>
                             
                        </div>
                    </div><!-- END .text-area -->
                </div><!-- END .outer-text-wrapper -->
            </div>
    {/if}
    {/each}
</section>
<section>
{#each categories as category}
{#if window.location.pathname.includes(`${category.pathIncludes}`)}
<div style="max-width: 1120px;
    margin: 20px auto; padding: 0 20px; padding-top:50px;">

<p class="recipe-cat-copy" style="max-width: 1120px;
    margin: 20px auto; padding: 0 20px;">{category.copy}</p>
</div>
{/if}
    {/each}
</section>